import React from 'react';
import AdminPanel from './AdminPanel';

const AdminRoute = () => {
  return <AdminPanel />;
};

export default AdminRoute;